import React from 'react'

import Button from '../../../Button'
import Field from '../../../Field'
import TimePicker from '../../../TimePicker'

type TCronTime = {
  index: number
  onRemove: (num: number) => void
  name: string
}

const CronTime = (props: TCronTime): React.ReactElement => {
  const { index, onRemove, name } = props

  const remove = (): void => onRemove(index)

  return (
    <div className="mx-n2">
      <div
        style={{ flex: '1', display: 'flex' }}
        className="justify-content-between"
      >
        <div>
          <Field name={`${name}`}>
            <TimePicker customWidth="60px" />
          </Field>
        </div>

        <div>
          <Button danger sm onClick={remove} disabled={index === 0}>
            <i className="fas fa-trash" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CronTime
